<template>
  <article
    class="form_modal">
    <section class="form_modal__container_video invitation_modal invitation_right">
        <div class="invitation_modal__content">
           <div class="invitation_modal__content--right">
                <h3>Enviar cortesía a:</h3>
                <div>
                    <label>Nombre y apellido</label>
                    <input v-model="mail.name" type="text" name="name" placeholder="Escribe el nombre completo" v-validate="'required'">
                    <span style="color:red; font-size:12px" v-show="errors.has('name')" class="showError">El campo nombre y apellido es requerido.</span>
                </div>
                <div>
                    <label>Cédula</label>
                    <input v-model="mail.rut" type="text" name="identification" placeholder="Escribe el número de identificación" v-validate="'required'">
                    <span style="color:red; font-size:12px" v-show="errors.has('identification')" class="showError">El campo cédula es requerido.</span>
                </div>
                <div>
                    <label>Correo electrónico</label>
                    <input v-model="mail.mail" type="email" name="email" placeholder="Escribe el correo electrónico" v-validate="'required|email'">
                    <span style="color:red; font-size:12px" v-show="errors.has('email')" class="showError">El campo debe tener un correo electrónico válido.</span>
                </div>
                <div>
                    <label>Celular</label>
                    <input v-model="mail.phone" type="text" name="phone" placeholder="Escribe el número de contacto" v-validate="'required|numeric'">
                    <span style="color:red; font-size:12px" v-show="errors.has('phone')" class="showError">El campo debe tener un número de celular válido.</span>
                </div>
                <div>
                    <div class="invitation_modal__date">
                        <label>Fecha y hora de ingreso</label>
                        <arrow-icon
                            color="#21D741"
                            height="16"
                            width="16"
                            style="transform: rotate(180deg); margin-left: 10px"
                            class="invitation_modal__date--icon"
                        ></arrow-icon>
                    </div>
                    <date-picker v-model="mail.datetime_begin" type="datetime" name="date_in" :confirm="true" placeholder="Selecciona una fecha" confirm-text="Seleccionar" format="YYYY/MM/DD hh:mm a" v-validate="'required'"></date-picker>
                    <span style="color:red; font-size:12px" v-show="errors.has('date_in')" class="showError">Debes seleccionar la fecha y hora de ingreso.</span>
                </div>
                <div>
                    <div class="invitation_modal__date">
                        <label>Fecha y hora de salida</label>
                        <arrow-icon
                            color="#ED1C24"
                            height="16"
                            width="16"
                            style="margin-left: 10px;"
                            class="invitation_modal__date--icon"
                        ></arrow-icon>
                    </div>
                    <date-picker v-model="mail.datetime_end" type="datetime" name="date_out" :confirm="true" placeholder="Selecciona una fecha" confirm-text="Seleccionar" format="YYYY/MM/DD hh:mm a" v-validate="'required'"></date-picker>
                    <span style="color:red; font-size:12px" v-show="errors.has('date_out')" class="showError">Debes seleccionar la fecha y hora de salida.</span>
                </div>
                <div class="invitation_modal__content--button_container">
                    <button
                      @click="handleCancel"
                      class="close_button">Cerrar</button>
                    <button
                      @click="formIsInError?'':sendInvitation()">
                      Enviar
                    </button>
                </div>
           </div>
        </div>
    </section>
  </article>
</template>
<script>
export default {
    data(){
        return{
            mail: {
                name: '',
                mail: '',
                phone: '',
                rut: '',
                datetime_begin: '',
                datetime_end: '',
                location_id: '',
            },
            fieldError:'',
            errorOpening: false,
            errorEnding: false,
            spacesInError: false,
            validator: ''
        }
    },
    mounted() {
        this.mail.location_id = this.$route.params.id
    },
    computed:{
        formIsInError(){
            var ans=false
            let fields=[]
            if(this.mail.name.length==0){
                fields.push("'Ingresa nombre'");
            }
            if(this.mail.mail.length==0){
                fields.push("'Ingresa correo electrónico'");
            }
            if(this.mail.phone.length==0){
                fields.push("'Ingresa telefono'")
            }
            if(this.mail.datetime_begin != null && this.mail.datetime_begin.length==0){
                fields.push("'Fecha Ingreso'")
            }
            if(this.mail.datetime_end != null && this.mail.datetime_end.length==0){
                fields.push("'Fecha Salida'")
            }
            if(this.scheduleIsInError){
                fields.push("''")
            }
            if(fields.length>0){
                if(fields.length==2){
                this.fieldError=fields.join(" y ")
                }else{
                this.fieldError=fields.join(" , ")
                }
                this.$validator.validateAll()
                ans=true
            }else{
                this.fieldError=""
            }
            return ans
        },
        scheduleIsInError(){
            var ans=false
            if(this.errorOpening||this.errorEnding||this.spacesInError){
                ans=true
            }
            return ans
        },
    },
    watch: {
        'mail.datetime_begin': function(){
            this.validateDateRange()
        },
        'mail.datetime_end': function(){
            this.validateDateRange()
        },
    },
    methods:{
        handleCancel(){
            this.$emit('handleCancelModalInvitation', false)
        },
        sendInvitation(){
            if(this.mail.datetime_begin === '' || this.mail.datetime_end === ''){
                this.updateAlertMessage('Por favor selecciona correctamente las fechas y horas de la invitación');
                this.updateIsInAlert(true);
            }else{
                // this.validator = this.mail.rut.substring(this.mail.rut.length - 1,this.mail.rut.length)
                var current_rut = this.mail.rut.replace(/\-|\./g,"")
                // console.log(current_rut.substring(0,current_rut.length - 1));
                // if(this.validator.toUpperCase() == this.validateRut(current_rut.substring(0,current_rut.length - 1))){
                    if (this.mail.mail !== this.getEmailUser()) {
                        if (this.getDeviceId() === '' || this.getDeviceId() === null || this.getDeviceId() === 'null'){
                            this.buildDeviceId()
                        }
                        try {
                            let time_send = new Date().getTime()
                            this.$http.post('app/bookings/invite',{
                                user_id: this.getUserId(),
                                time_send: time_send,
                                device_id: this.getDeviceId(),
                                user_id_encrypt: this.getUserIdEncrypt(),
                                begin: new Date(this.mail.datetime_begin).toLocaleString("sv", {timeZoneName: "short"}).substring(0,16),
                                end: new Date(this.mail.datetime_end).toLocaleString("sv", {timeZoneName: "short"}).substring(0,16),
                                begin_server: new Date(this.mail.datetime_begin).toISOString().replace('T',' ').replace('Z',''),
                                end_server: new Date(this.mail.datetime_end).toISOString().replace('T',' ').replace('Z',''),
                                email: this.mail.mail.toLowerCase(),
                                name: this.mail.name,
                                phone: this.mail.phone,
                                rut: current_rut,
                                location_id: this.mail.location_id
                            },{
                            headers:{
                                "X-Device-ID" : this.getDeviceId(),
                                "Authorization" : 'Bearer ' + this.getUserToken()
                            }
                            })
                            .then(function(response){
                                console.log('SEND INVITATION ',response)
                                this.handleCancel();
                                if(response.body.ans == "Se ha realizado la invitación con éxito"){
                                    this.updateAlertMessage("Se ha enviado la cortesía con éxito");
                                }else{
                                    this.updateAlertMessage(response.body.ans);
                                }
                                this.updateIsInAlert(true);
                                if(response.body.meta != undefined && response.body.meta != null){
                                    if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                                        this.checkToken(response.body.meta.authentication_token)
                                    }
                                }
                                }, function(response){
                                if (response.status==401) {
                                    alert("Tienes una sesión abierta en otro dispositivo.", "Un momento...");
                                }else{
                                    // alert(response.body.errors[0].details);
                                    this.updateAlertMessage(response.body.errors[0].details);
                                    this.updateIsInAlert(true);
                                }
                                if(response.body.meta != undefined && response.body.meta != null){
                                    if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                                        this.checkToken(response.body.meta.authentication_token)
                                    }
                                }
                            })
                        } catch (e) {
                            alert(e.message)
                        }
                    } else {
                        this.updateAlertMessage('No se puede generar una invitación para el mismo usuario')
                        this.updateIsInAlert(true);
                    }
                // } else {
                //     this.updateAlertMessage('El Rut no es válido')
                //     this.updateIsInAlert(true);
                // }
            }
        },
        validateDateRange(){
            let begin = ''
            let end = ''
            let actual_date = new Date()
            actual_date = actual_date.setMinutes(actual_date.getMinutes() - 1);
            if(this.mail.datetime_begin != ''){
                begin = new Date(this.mail.datetime_begin).getTime()
            }
            if(this.mail.datetime_end){
                end = new Date(this.mail.datetime_end).getTime()
            }
            if(begin < actual_date){
                this.updateAlertMessage('La fecha de ingreso no puede ser inferior a la fecha actual')
                this.updateIsInAlert(true)
                this.mail.datetime_begin = ''
            }
            if(begin !== '' && end !== ''){
                if(end <= begin){
                    this.updateAlertMessage('La fecha de salida no puede ser inferior o igual a la fecha de entrada');
                    this.updateIsInAlert(true)
                    this.mail.datetime_end = ''
                }
            }
        },
        validateRut(indexed_rut){
            console.log(indexed_rut);
            var rut = indexed_rut.toString().replace(/\.|\-/g,'').split('').reverse().map(Number)
            var multiplier = 2
            var sum = 0
            var validator = null
            for (var i = 0; i < rut.length; i++) {
                rut[i] = rut[i]*multiplier
                sum = sum + rut[i]
                if (multiplier < 7) {
                multiplier += 1
                } else {
                multiplier = 2
                }
            }
            validator = 11 - (sum%11)
            console.log(validator);
            switch (validator) {
                case 11:
                return '0'
                break;
                case 10:
                return 'K'
                break;
                default:
                return validator.toString().toUpperCase();
                break;
            }
        },
        buildDeviceId(){
            var uuid
            if(localStorage.device_id != undefined &&
                localStorage.device_id != null &&
                localStorage.device_id != '' &&
                localStorage.device_id != 'null'){
                uuid = localStorage.device_id
            } else {
                uuid = this.$uuid.v1()
                localStorage.device_id = uuid
            }
            console.log("DEVICE ID!!!!!!!!!!!!!!!!!!!!!!");
            console.log(uuid);
            this.updateDeviceId(uuid);
            return uuid
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/invitations/ModalInvitation.vue